import api from "../_api";

const actions = {
    getVenues: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit("PRODUCTS_LOADING");

            api.venues()
                .then(venues => {
                    commit("PRODUCT_VENUES", venues.data);
                    resolve(venues.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    }

                    commit("PRODUCTS_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
    getProductVenues: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit("PRODUCTS_LOADING");

            api.productvenues()
                .then(venues => {
                    commit("PRODUCT_VENUES", venues.data);
                    resolve(venues.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    }

                    commit("PRODUCTS_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
    getCategories: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit("PRODUCTS_LOADING");

            let payload_orig = '';

            if(payload){
                payload_orig = payload.orig;
            }

            api.categories(payload_orig)
                .then(categories => {
                    commit("PRODUCT_CATEGORIES", categories.data);
                    resolve(categories.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    }

                    commit("PRODUCTS_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
    getProducts: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit("PRODUCTS_LOADING");

            let payload_orig = '';

            if(payload){
                payload_orig = payload.orig;
            }

            api.products(payload_orig)
                .then(products => {
                    commit("PRODUCTS", products.data);
                    resolve(products.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    }

                    commit("PRODUCTS_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
    checkAttendee: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit("SHOPPING_LOADING");

            api.checkattendee(payload.attendee)
                .then(resp => {
                    // commit('TEAM_NOMINATION_SUCCESS', resp.data);
                    resolve(resp.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                        errorMsg = errors;
                    }

                    commit("SHOPPING_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
    showCartState: ({ commit }, value) => {
        commit("SHOW_CART_STATE", value);
    },
    addProductToCart: ({ commit }, product) => {
        commit("ADD_TO_CART", product);
        commit("STORE_CART");
    },
    addProductQuantityToCart: ({ commit }, product) => {
        commit("ADD_QTY_TO_CART", product);
        commit("STORE_CART");
    },
    removeProductQuantityToCart: ({ commit }, product) => {
        commit("REMOVE_QTY_TO_CART", product);
        commit("STORE_CART");
    },
    removeProductFromCart: ({ commit }, product) => {
        commit("REMOVE_FROM_CART", product);
        commit("STORE_CART");
    },
    payShoppingCart: ({ commit, dispatch, state }, payload) => {
        let data = {
            attendees: payload.attendees,
            assign: payload.assign,
            couponCart: payload.couponCart,
            donationCart: payload.donationCart,
            cardData: payload.cardPayload,
            shoppingCart: state.shoppingCart,
        };

        return new Promise((resolve, reject) => {
            commit("PAYMENT_LOADING");

            api.payshoppingcart(data)
                .then(resp => {
                    commit("REMOVE_CART");
                    commit("PAYMENT_SUCCESS", resp.data);
                    dispatch("user/userRequest", null, { root: true });
                    resolve(resp.data.data.o_id);
                })
                .catch(err => {
                    let errors = err.response.data;

                    commit("PAYMENT_ERROR", errors);
                    reject(err.response);
                });
        });
    },
    clearPaymentErrors: ({ commit }) => {
        commit("CLEAR_PAYMENT_ERRORS");
    },
};

export default actions;
